import React from 'react';
import { AnimatePresence } from 'framer-motion';
import { Alert } from './Alert';
import { useAlert } from '../contexts/AlertContext';

/**
 * Container component for displaying alerts
 */
export const AlertContainer: React.FC = () => {
    const { alerts, removeAlert } = useAlert();

    return (
        <div style={{
            position: 'fixed',
            bottom: '20px',
            right: '20px',
            zIndex: 9999,
            maxWidth: '400px',
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-end',
        }}>
            <AnimatePresence mode="popLayout">
                {alerts.map((alert) => (
                    <Alert
                        key={alert.id}
                        type={alert.type}
                        message={alert.message}
                        action={alert.action}
                        onClose={() => removeAlert(alert.id)}
                        autoClose={alert.type === 'success'}
                    />
                ))}
            </AnimatePresence>
        </div>
    );
};

// Export the hook for use in other components
export { useAlert } from '../contexts/AlertContext';
